import { ReactElement } from 'react';
import benLogo from 'components/assets/img/ben_labs_logo_black.png';

import './ScreensNotPPTeamGate.scss';

/**
 * Redirects user to the main BEN Labs application
 */
const handleRedirect = (): void => {
  window.location.href = 'https://app.benlabs.com/team/search';
};

/**
 * Displays an informational page for users who have accessed the wrong BEN platform
 */
function ScreensInfPlatform(): ReactElement {
  return (
    <div className="not-pp-team-gate__wrapper">
      <div className="not-pp-team-gate__logo">
        <img src={benLogo} alt="BEN Logo" />
        <span className="app-header-product-placement">PRODUCT PLACEMENT</span>
      </div>

      <div className="not-pp-team-gate-content">
        <p className="not-pp-team-gate-title">
          <b>
            <i>
              ⁉️ Is this the <b>BEN App</b> you are looking for? ⁉️
            </i>
          </b>
        </p>

        <p>
          This version of the <b>BEN App</b> is designed just for Product
          Placement,
          <br />
          we have detected <b>you are not part of the Product Placement team</b>
          .
        </p>
        <p>
          <b>
            You probably want to be on the original{' '}
            <a href="https://app.benlabs.com/team/">app.BENlabs.com</a>
          </b>
        </p>
      </div>

      <div>
        <button type="button" className="go-to-pp" onClick={handleRedirect}>
          Take me to <b>app.BENlabs.com</b>
        </button>

        <div className="not-pp-team-gate-label">
          <i>
            * If you are on the product placement team, or do need access here,
            please reach out on slack{' '}
            <a href="https://bengroupall.slack.com/archives/C076JLH92R1">
              #pp-tech-questions
            </a>{' '}
            ! 😊
          </i>
        </div>
      </div>
    </div>
  );
}

export default ScreensInfPlatform;
